import { page as pageIndex } from '../../globals'
import {
  matchParameters,
  sortFieldList,
  mapGroupNotesOptionsValues,
  mapGroupNotesFieldList,
  returnDateFormat } from './helpers'
import {
  START_DATA_FETCH,
  DATA_FETCHED,
  FETCH_FAILED,
  SAVE_GROUP_NOTES_OPTIONS,
  RETURN_DEFAULT_REPORT,
  OPEN_SAVED_REPORT,
  getFormDataHandlers,
  actionGroupNoteHandler } from './getFormData'
import { UPDATE_DATA, actionHandler } from './updateData'
import { CLEAR_FILTERS } from './reportLine'
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [START_DATA_FETCH] : getFormDataHandlers['START_DATA_FETCH'],
  [FETCH_FAILED] : getFormDataHandlers['FETCH_FAILED'],
  [DATA_FETCHED] : (state, action) => {
    const { page, field } = action.location
    const { json } = action.payload
    const mappedApiData = mapGroupNotesFieldList(json.FieldList)
    if (page !== pageIndex.local) {
      return state
    }
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        [page]: {
          ...state.renderData[page],
          [field]: {
            fieldList: sortFieldList(json.FieldList),
            fieldOptions: mapGroupNotesOptionsValues(json.FieldOptions),
            regionList: json.RegionList,
            subjectList: json.SubjectList,
            favoritesList: json.FavoritesList,
            archiveStartYear: json.ArchiveStartYear,
            clientId: json.ClientId,
            userId: json.UserId,
            defaultReport: json.DefaultReport
          }
        }
      },
      formDataValue: {
        ...state.formDataValue,
        [page]: {
          ...state.formDataValue[page],
          [field]: {
            ...state.formDataValue[page][field],
            radio: {
              ...state.formDataValue[page][field].radio,
              ...mappedApiData.radio,
            },
            dateTime: {
              ...state.formDataValue[page][field].dateTime,
              ...mappedApiData.dateTime,
            },
            textValues: {
              ...state.formDataValue[page][field].textValues,
              ...mappedApiData.textValues
            }
          }
        }
      }
    }
  },
  [SAVE_GROUP_NOTES_OPTIONS] : (state, action) => action.location.page !== pageIndex.local
    ? state : actionGroupNoteHandler(state, action),
  [UPDATE_DATA] : (state, action) => action.location.page !== pageIndex.local ? state : actionHandler(state, action),
  [CLEAR_FILTERS] : (state, action) => {
    const { page } = action
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        [page]: {
          ...clearState.formDataValue[page],
        }
      }
    }
  },
  [RETURN_DEFAULT_REPORT] : (state, action) => {
    const { page } = action
    if (page !== pageIndex.local) {
      return {
        ...state
      }
    }
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        [page]: {
          ...initialState.formDataValue[page],
          groupNotesOptions: {
            selected: [
              ...state.formDataValue[page].groupNotesOptions.selected,
            ],
            radio: {
              sw0h: false,
            }
          }
        }
      },
      renderData: {
        ...state.renderData,
      }
    }
  },
  [OPEN_SAVED_REPORT] : (state, action) => {
    const { page } = action
    const { json } = action.payload
    if (page !== pageIndex.local || json === undefined) {
      return {
        ...state,
      }
    } else {
      const criteria = matchParameters(json.ReportCriteria)
      const favorites = criteria.filters.personalreport ? criteria.filters.personalreport : []
      return {
        ...state,
        isFetchingData: false,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            defaultSearch: {
              ...state.formDataValue[page].defaultSearch,
              title: json.Name,
              textValues: {
                ...state.formDataValue[page].defaultSearch.textValues,
                reporttitle: criteria.filters.reporttitle || '',
              },
              dateTime: {
                recorddatestart: criteria.filters.recorddatestart
                  ? returnDateFormat(criteria.filters.recorddatestart)
                  : new Date(new Date().getFullYear(), 0, 1),
                recorddateend: criteria.filters.recorddateend
                  ? returnDateFormat(criteria.filters.recorddateend) : new Date(),
                meetingdatestart: criteria.filters.meetingdatestart
                  ? returnDateFormat(criteria.filters.meetingdatestart) : ' ',
                meetingdateend: criteria.filters.meetingdateend
                  ? returnDateFormat(criteria.filters.meetingdateend) : ' ',
              },
              radio: {
                reporttype: criteria.filters.reporttype[0] || 'alltracked',
              },
              selected: []
            },
            viewingOptions: {
              selected: criteria.viewingOptions.selected || [],
              radio: {
                histlist: criteria.viewingOptions.historyRadioButton,
                howmany: criteria.viewingOptions.howmany,
              },
            },
            advancedEditingTools: {
              selected: criteria.advancedEditingTools.selected || [],
              radio: {
                sortheader: !!criteria.advancedEditingTools.sortheader,
                sort1: criteria.advancedEditingTools.sort1[0],
                sort2: criteria.advancedEditingTools.sort2[0],
                sort3: criteria.advancedEditingTools.sort3[0],
                sort4: criteria.advancedEditingTools.sort4[0],
              }
            },
            reportFormat: {
              selected: criteria.mapOptions.selectedAdvancedOptions
                ? [criteria.mapOptions.selectedAdvancedOptions] : [],
              radio: {
                mapit: !!criteria.mapOptions.mapit,
                outformat: criteria.mapOptions.outformat[0],
              }
            },
            maps: {
              selected: criteria.mapOptions.selected || [],
              textValues: {
                lowcountcolor: criteria.mapOptions.lowcountcolor ||
                state.formDataValue[page].maps.textValues.lowcountcolor,
                medcountcolor: criteria.mapOptions.medcountcolor ||
                state.formDataValue[page].maps.textValues.medcountcolor,
                highcountcolor: criteria.mapOptions.highcountcolor ||
                state.formDataValue[page].maps.textValues.highcountcolor,
                foundbillscolor: criteria.mapOptions.foundbillscolor ||
                state.formDataValue[page].maps.textValues.foundbillscolor,
              },
            },
            groupNotesOptions: {
              selected: criteria.groupNotesOptions || [],
              radio: {
                sw0h: false,
              }
            },
            additionalFilters: {
              textValues: {
                title: criteria.filters.title || '',
                summary: criteria.filters.summary || '',
                history: criteria.filters.history || '',
                personalnotes: criteria.filters.personalnotes || '',
              },
              dateTime: {
                actiondatestart: criteria.filters.personalnotesstart
                  ? returnDateFormat(criteria.filters.personalnotesstart) : ' ',
                actiondateend: criteria.filters.actiondateend
                  ? returnDateFormat(criteria.filters.actiondateend) : ' ',
                personalnotesstart: criteria.filters.personalnotesstart
                  ? returnDateFormat(criteria.filters.personalnotesstart) : ' ',
                personalnotesend: criteria.filters.personalnotesend
                  ? returnDateFormat(criteria.filters.personalnotesend) : ' ',
              }
            },
            archivedYear: {
              selected: criteria.filters.archive ? [criteria.filters.archive] : ['current'],
            },
            archivedSubjects: {
              selected: criteria.filters.archivedsubject ? [criteria.filters.archivedsubject] : [],
            },
            groupNotes: {
              selected: criteria.filters.noteslastupdateunassigned === 'true'
                ? ['noteslastupdateunassigned']
                : [],
              radio: {
                noteslogic: criteria.filters.noteslogic === 'and' || criteria.filters.noteslogic === undefined
                  ? 'ALL selected Group Notes criteria must be true.'
                  : 'ANY selected Group Notes criteria must be true.'
              },
              dateTime: {
                noteslastupdatestart: criteria.filters.noteslastupdatestart
                  ? returnDateFormat(criteria.filters.noteslastupdatestart) : ' ',
                noteslastupdateend: criteria.filters.noteslastupdateend
                  ? returnDateFormat(criteria.filters.noteslastupdateend) : ' ',
              },
            },
            favorites: {
              selected: criteria.filters.notinpersonalreport === 'true' ? [...favorites, 'notinpersonalreport'] : []
            },
            progress: {
              selected: criteria.filters.progress ? [criteria.filters.progress] : []
            },
            subjects: {
              selected: criteria.filters.subjects ? [criteria.filters.subjects] : []
            },
            locality: {
              selected: criteria.filters.states ? [criteria.filters.states] : []
            }
          }
        },
        renderData: {
          ...state.renderData,
          [page]: {
            ...state.renderData[page],
            groupNotes: {
              ...state.renderData[page].groupNotes,
              selectedReport: json,
            }
          }
        }
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
const clearState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {
    O: {
      groupNotes: {},
    },
  },
  formDataValue: {
    O: {
      viewingOptions: {
        selected: [],
        radio: {
          histlist: '',
          howmany: '25',
        },
      },
      defaultSearch : {
        title: 'Default Search',
        textValues: {
          reporttitle: '',
          citation: '',
        },
        radio: {
          reporttype: 'alltracked',
        },
        dateTime: {
          recorddatestart: new Date(new Date().getFullYear(), 0, 1),
          recorddateend: new Date(),
          meetingdatestart: ' ',
          meetingdateend: ' ',
          dt2fr: ' ',
          dt2to: ' ',
        },
        selected: ['cb4date']
      },
      groupNotes: {
        selected: [],
        radio: {
          noteslogic: 'ALL selected Group Notes criteria must be true.',
        },
        dateTime: {
          noteslastupdatestart: ' ',
          noteslastupdateend: ' ',
        },
      },
      groupNotesOptions: {
        selected: [],
        radio: {
          sw0h: false,
        }
      },
      additionalFilters: {
        textValues: {
          title: '',
          history: '',
          summary: '',
          personalnotes: '',
        },
        dateTime: {
          dt0if: ' ',
          dt1it: ' ',
          personalnotesstart: ' ',
          personalnotesend: ' ',
        }
      },
      advancedEditingTools: {
        selected: [],
        radio: {
          sortheader: false,
          sort1: 'locality',
          sort2: 'title',
          sort3: 'meetingdate',
          sort4: 'subject',
        }
      },
      reportFormat: {
        selected: [],
        radio: {
          mapit: false,
          outformat: 'html',
        }
      },
      recordType: {
        selected: [],
      },
      carryOrders: {
        selected: [],
      },
      archivedYear: {
        selected: ['current'],
      },
      archivedSubjects: {
        selected: [],
      },
      subjects: {
        selected: [],
      },
      favorites: {
        selected: [],
      },
      locality: {
        selected: [],
      },
      progress: {
        selected: [],
      },
      priority: {
        selected: [],
      },
      position: {
        selected: [],
      },
      revenue: {
        selected: [],
      },
      compliance: {
        selected: [],
      },
      department: {
        selected: [],
      },
      maps: {
        selected: [],
        textValues: {
          lowcountcolor: '#9cc1e6',
          medcountcolor: '#4175b2',
          highcountcolor: '#243e66',
          foundbillscolor: '#4175b2',
        },
      },
    },
  },
}
const initialState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {
    O: {
      groupNotes: {},
    },
  },
  formDataValue: {
    O: {
      viewingOptions: {
        selected: [
          'viewsearchcriteria', 'viewemailalerts', 'viewemailit',
          'viewcontactinfo', '', '',
          'viewlinks', 'viewsubject', 'viewsummary',
          'viewhistory', 'viewremarks', '',
          'viewpersonalnotes', 'viewpersreports'
        ],
        radio: {
          histlist: 'History by Line',
          howmany: '25',
        },
      },
      defaultSearch : {
        title: 'Default Search',
        textValues: {
          reporttitle: 'Local Report',
        },
        cb: {
          cb4date: {},
        },
        radio: {
          reporttype: 'alltracked',
        },
        dateTime: {
          recorddatestart: new Date(new Date().getFullYear(), 0, 1),
          recorddateend: new Date(),
          meetingdatestart: ' ',
          meetingdateend: ' ',
          dt2fr: ' ',
          dt2to: ' ',
        },
        selected: []
      },
      groupNotes: {
        selected: [],
        radio: {
          noteslogic: 'ALL selected Group Notes criteria must be true.',
        },
        dateTime: {
          noteslastupdatestart: ' ',
          noteslastupdateend: ' ',
        },
      },
      groupNotesOptions: {
        selected: ['editnotes', 'viewnoteslastupdated'],
        radio: {
          sw0h: false,
        }
      },
      additionalFilters: {
        textValues: {
          title: '',
          history: '',
          summary: '',
          personalnotes: '',
        },
        dateTime: {
          dt0if: ' ',
          dt1it: ' ',
          personalnotesstart: ' ',
          personalnotesend: ' ',
        }
      },
      advancedEditingTools: {
        selected: [],
        radio: {
          sortheader: false,
          sort1: 'locality',
          sort2: 'title',
          sort3: 'meetingdate',
          sort4: 'subject',
        }
      },
      reportFormat: {
        selected: [],
        radio: {
          mapit: false,
          outformat: 'html',
        }
      },
      recordType: {
        selected: [],
      },
      carryOrders: {
        selected: [],
      },
      archivedYear: {
        selected: ['current'],
      },
      archivedSubjects: {
        selected: [],
      },
      subjects: {
        selected: [],
      },
      favorites: {
        selected: [],
      },
      locality: {
        selected: [],
      },
      progress: {
        selected: [],
      },
      priority: {
        selected: [],
      },
      position: {
        selected: [],
      },
      revenue: {
        selected: [],
      },
      compliance: {
        selected: [],
      },
      department: {
        selected: [],
      },
      maps: {
        selected: [],
        textValues: {
          lowcountcolor: '#9cc1e6',
          medcountcolor: '#4175b2',
          highcountcolor: '#243e66',
          foundbillscolor: '#4175b2',
        },
      },
    },
  },
}
export default function localDataReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/localFormData.js